/** A Uruguayan RUC is exactly 12 digits. */
export const RUT_DIGITS = 12;

/**
 * True when `raw` carries exactly 12 digits, ignoring punctuation.
 *
 * Validate the RAW input with this — never the output of `normalizeRut`, which
 * ends in `.padStart(12, "0").slice(0, 12)` and therefore ALWAYS returns a
 * 12-character string. Checking `normalizeRut(x).length !== 12` is dead code:
 * it silently accepted an empty or too-short RUT, and worse, padded a 5-digit
 * typo into "000000012345" — a well-formed RUC belonging to somebody else,
 * which then went to DGI on a real CFE without complaint.
 */
export function hasValidRutDigits(raw: string | null | undefined): boolean {
  const digits = (raw ?? "").replace(/\D/g, "");
  return digits.length === RUT_DIGITS;
}
